<template>
  <div class="dashboard-pages">
    <v-card class="pa-3">
      <v-layout row>
        <v-layout row justify-start align-end>
          <v-flex shrink>
            <v-tooltip :left="!$vuetify.rtl" :right="$vuetify.rtl">
              <template v-slot:activator="{ on }">
                <v-btn
                  style="margin: 5px 0px; height: 30px; width: 30px"
                  flat
                  fab
                  v-on="on"
                  color="primary"
                  @click="getNoPaginatedData('print')"
                >
                  <v-icon>print</v-icon>
                </v-btn>
              </template>
              <span>{{ $t(`Print Table`) }}</span>
            </v-tooltip>
            <v-tooltip :left="!$vuetify.rtl" :right="$vuetify.rtl">
              <template v-slot:activator="{ on }">
                <v-btn
                  style="margin: 5px 20px 5px 10px; height: 30px; width: 30px"
                  fab
                  flat
                  v-on="on"
                  color="primary"
                  @click="getNoPaginatedData('export')"
                >
                  <v-icon>fa-file-excel</v-icon>
                </v-btn>
              </template>
              <span>{{ $t(`Export Table`) }}</span>
            </v-tooltip>
          </v-flex>
        </v-layout>

        <v-layout row justify-end>
          <v-flex xs5 pa-2>
            <v-autocomplete
              v-if="hasPermissions(['outlet_select'])"
              v-model="outlet_id"
              :label="`${$t('Outlet')} *`"
              hide-details
              :items="outletsList"
              @input="updateDatatableResult()"
              data-vv-name="outlet"
              :error="errors.has('outlet')"
              v-validate="'required'"
            />
          </v-flex>

          <v-flex xs3 pa-2>
            <v-menu v-model="dateMenu" full-width max-width="290" :close-on-content-click="false">
              <v-text-field
                slot="activator"
                :value="date"
                :label="$t('Date')"
                prepend-inner-icon="event"
                hide-details
                readonly
                name="Date"
                :error="errors.has('Date')"
                v-validate="'required|date_format:yyyy-MM-dd'"
              />
              <v-date-picker @input="updateDatatableResult()" @change="dateMenu = false" v-model="date" :max="today" />
            </v-menu>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-card>

    <v-card px-4 pb-4>
      <v-data-table
        :headers="headers"
        :items="resultData.trial"
        :item-key="defaultSortBy"
        :loading="loading"
        :no-data-text="$t('No available data')"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <!--          <td>{{ props.item.account_chart_id }}</td>-->
          <td style="width: 50px"></td>
          <td>{{ $t(props.item.account_chart_name.trim()) }}</td>
          <td>{{ props.item.debit | currency }}</td>
          <td>{{ props.item.credit | currency }}</td>
          <td style="width: 150px"></td>
        </template>

        <template v-slot:footer>
          <td></td>
          <td>
            <strong>{{ $t('Total') }}</strong>
          </td>
          <td>
            <strong>{{ resultData.total_debit | currency }}</strong>
          </td>
          <td>
            <strong>{{ resultData.total_credit | currency }}</strong>
          </td>
          <td></td>
        </template>
      </v-data-table>
    </v-card>

    <print-export-component
      :printExportDialog="dialogs.printExportDialog"
      :tableHeader="tableHeader"
      :tableBody="tableBody"
      :clickedButton="clickedButton"
      @hidemodal="dialogs.printExportDialog = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions'

export default {
  components: {
    printExportComponent: () => import('@/views/_partials/printExportComponent.vue')
  },

  data() {
    return {
      dialogs: {
        printExportDialog: false
      },
      tableBody: [],
      tableHeader: [],
      loadThePrintBtn: false,
      loadTheExportBtn: false,
      clickedButton: '',
      outlet_id: 0,
      dateMenu: false,
      today: this.$moment()
        .format()
        .substr(0, 10),
      date: this.$moment()
        .format()
        .substr(0, 10),
      loading: false,
      defaultSortBy: 'account_chart_name',
      headers: [
        // {
        //   text: this.$t('ID'),
        //   value: 'account_chart_id',
        //   align: 'left',
        //   sortable: true
        // },
        { text: '', value: '', sortable: false },
        { text: this.$t('Account Name'), value: 'account_chart_name' },
        {
          text: `${this.$t('Debit')} (${localStorage.systemCurrency})`,
          value: 'debit'
        },
        {
          text: `${this.$t('Credit')} (${localStorage.systemCurrency})`,
          value: 'credit'
        },
        { text: ``, value: '', sortable: false }
      ],
      allowGettingData: true
    }
  },

  mounted() {
    this.setAppBarTitle({
      title: this.$t('Trial Balance Report'),
      icon: 'fa-chart-line'
    })

    this.fetchOutletList()
    this.updateDatatableResult()
  },

  computed: {
    ...mapGetters({
      resultData: 'trialBalance/getTrialBalanceList',
      outletsList: 'outlets/getFullReportOutletsList'
    })
  },

  methods: {
    ...mapActions({
      resetAllErrors: 'errors/resetAllErrors',
      setErrorsList: 'errors/setErrorsList',
      updateResult: 'trialBalance/fetchTrialBalanceList',
      fetchOutletList: 'outlets/setFullOutletsList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    getNoPaginatedData(clickedButton) {
      this.clickedButton = clickedButton
      this.tableBody = []
      this.tableHeader = []
      this.tableHeader = this.headers
      this.tableHeader = this.tableHeader.filter(f => f.text !== '')

      this.tableBody = this.resultData.trial
      this.dialogs.printExportDialog = true
    },

    updateDatatableResult() {
      this.loading = true
      let payload = {
        outlet_id: this.outlet_id,
        date: this.date
      }
      this.updateResult(payload)
        .then(() => {
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    resetDataTable() {
      this.updateDatatableResult()
    }
  }
}
</script>

<style scoped />
